import { VALAQUENTA_API_URL } from "../..";
import { authorizedAxios } from "../../../App";

export function fetchBackUpStatus() {
  return authorizedAxios.get(
    `${VALAQUENTA_API_URL}/highinquisitor/backup-status/`
  );
}
